import { EАctiveTabActionTypes, IInitializeFromUrlActionPayload, ISetActiveTabActionPayload } from './types';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export const setActiveTab = actionGenerator<EАctiveTabActionTypes.SET_ACTIVE_TAB, ISetActiveTabActionPayload>(
  EАctiveTabActionTypes.SET_ACTIVE_TAB,
);

export const initializeActiveTabFromUrl = actionGenerator<
  EАctiveTabActionTypes.INITIALIZE_FROM_URL,
  IInitializeFromUrlActionPayload
>(EАctiveTabActionTypes.INITIALIZE_FROM_URL);
